export default __webpack_public_path__ + "static/media/screw.86cf0b44.png";